module.exports = __webpack_public_path__ + "static/memoji-item-268212413ef9081c7f59303374cfd801.png";